import React, { useState } from 'react';

const REASONS = [
  { value: 'spam', label: 'Spam' },
  { value: 'inappropriate', label: 'Inappropriate content' },
  { value: 'harassment', label: 'Harassment' },
  { value: 'misinformation', label: 'Misinformation' },
  { value: 'other', label: 'Other' },
];

export default function ReportModal({ contentType, contentId, onClose }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  async function submit() {
    if (!reason || submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      const res = await fetch('/api/reports', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contentType, contentId, reason }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.ok) throw new Error(data.error || 'Failed to submit report');
      setDone(true);
    } catch (e) {
      setError(e.message || 'Something went wrong');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flique-report-backdrop" role="dialog" aria-modal="true" aria-label="Report content">
      <div className="flique-report-modal">
        <div className="flique-report-header">
          <span className="flique-report-title">Report {contentType}</span>
          <button className="flique-report-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        {done ? (
          <div className="flique-report-done">
            <p>Thanks, your report has been submitted.</p>
            <button className="btn btn-sm btn-outline-light mt-2" onClick={onClose}>Close</button>
          </div>
        ) : (
          <>
            <p className="flique-report-prompt">Why are you reporting this?</p>
            <ul className="flique-report-reasons">
              {REASONS.map((r) => (
                <li key={r.value}>
                  <label className="flique-report-reason-label">
                    <input
                      type="radio"
                      name="report-reason"
                      value={r.value}
                      checked={reason === r.value}
                      onChange={() => setReason(r.value)}
                    />
                    <span>{r.label}</span>
                  </label>
                </li>
              ))}
            </ul>
            {error ? <p className="flique-report-error">{error}</p> : null}
            <div className="flique-report-actions">
              <button className="btn btn-sm btn-outline-light" onClick={onClose} disabled={submitting}>
                Cancel
              </button>
              <button
                className="btn btn-sm btn-flique"
                onClick={submit}
                disabled={!reason || submitting}
              >
                {submitting ? 'Submitting…' : 'Submit report'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
